
import React from "react";
import { Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import NavbarUser from "components/login/NavbarUser";


function Topbar(props) {
    return (
        <Navbar className="sticky-top" id="topbar" collapseOnSelect expand="lg" bg="dark" variant="dark">
                <Navbar.Brand as={Link} to="/">    
                <img
                    src={"/survey/logo-cba.svg"}
                    className="topbar-logo"
                    alt="CBA Group"
                />
                Survey System
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <NavbarUser className="ml-auto" />
                </Navbar.Collapse>
            </Navbar>
    );
}

export default Topbar;
